import {Utils} from '@astek/utils';
import {JsonConfigInterface} from './json-config-interface';
import {ColorConfig, ColorConfigJson} from './color-config';

export type ArrowsConfigJson =  {
  width: number;
  color: ColorConfigJson;
  background: ColorConfigJson;
  middleBackgroundSize: number;
  sideBackgroundSize: number;
};

export class ArrowsConfig implements JsonConfigInterface<ArrowsConfigJson> {

  public readonly color: ColorConfig = new ColorConfig();
  public readonly background: ColorConfig = new ColorConfig();

  private _width: number = 0;
  private _middleBackgroundSize: number = 0;
  private _sideBackgroundSize: number = 0;

  constructor(json?: ArrowsConfigJson) {
    if (!Utils.isNullOrUndefined(json)) {
      this.deserializeJson(json);
    }
  }

  public get width(): number {
    return this._width;
  }

  public get middleBackgroundSize(): number {
    return this._middleBackgroundSize;
  }

  public get sideBackgroundSize(): number {
    return this._sideBackgroundSize;
  }

  public deserializeJson(json: ArrowsConfigJson): void {
    this._width = json.width;
    this.color.deserializeJson(json.color);
    this.background.deserializeJson(json.background);
    this._middleBackgroundSize = json.middleBackgroundSize;
    this._sideBackgroundSize = json.sideBackgroundSize;
  }
}
